module.exports = __webpack_public_path__ + "img/gbt3736_1_4a.prt.41799a5a.jpg";